// import {
//   PricingCalculation,
//   PricingPeriod,
//   PricingPlan
// } from '@atlassian/bxp-product-pricing';
// import { usePricingCalculator } from '../contexts';
// import { AsyncResult, useAsync } from './use-async';
//
// type MinimalProductState = { key: string; units: number };
//
// const reduceCalcs = (calcs: PricingCalculation[]) =>
//   calcs.reduce((total, calc) => calc.total + total, 0);
//
// export function useTotal(
//   products: MinimalProductState[],
//   addons: Array<{ pricingPlan: PricingPlan; units: number }>,
//   currencyIsoCode: string,
//   period: PricingPeriod
// ): AsyncResult<number> {
//   const calculator = usePricingCalculator();
//   return useAsync(async () => {
//     const productsTotal = await Promise.all(
//       products.map((product) =>
//         calculator.calculatePrice({
//           productKey: product.key,
//           units: product.units,
//           period,
//           currencyIsoCode
//         })
//       )
//     ).then(reduceCalcs);
//
//     const addonsTotal = await Promise.all(
//       addons.map(async (addon) => {
//         try {
//           return await calculator.calculatePriceWithPricingPlan({
//             units: addon.units,
//             currencyIsoCode,
//             pricingPlan: addon.pricingPlan
//           });
//         } catch (e) {
//           // https://hello.atlassian.net/browse/WCF-1173
//           // temp fix for apps with tier limits below 5000
//           return {
//             currencyIsoCode,
//             total: 0,
//             breakdown: [],
//             pricingPlan: []
//           };
//         }
//       })
//     ).then(reduceCalcs);
//
//     return productsTotal + (addonsTotal || 0);
//   }, [products, addons, currencyIsoCode, period]);
// }
